<template>
	<div class="mh-div">
		<div class="mh-div-one" v-for="(item, index) in paintcollect" :key="index">
			<img :src="item.cover_pic" alt @click="toCartooninfo(item.id)" />
			<p class="mh-myp" @click="toCartooninfo(item.id)">{{item.title}}</p>
			<p class="mh-myp1">阅读至：</p>
			<p class="mh-myp2">{{item.episodes[0].title}}</p>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				paintcollect: ""
			};
		},
		methods: {
			toCartooninfo(id) {
				const InfoDetail = this.$router.resolve({
					name: "Catalog",
					query: { id: id }
				});
				window.open(InfoDetail.href, "_blank");
			}
		},
		beforeCreate() {
			this.$http
				.post("user/getbm/", {
					token: this.$cookies.get("token"),
					type: "paint"
				})
				.then(res => {
					if (res.body.code == 1) {
						this.paintcollect = res.body.data;
					}
				});
		}
	};
</script>

<style>
	.mh-div {
		width: 100%;
		display: flex;
		flex-wrap: wrap;
	}

	.mh-div-one {
		width: 190px;
		margin: 10px 10px 0;
	}

	.mh-div-one > img {
		width: 190px;
		height: 250px;
		cursor: pointer;
	}

	.mh-myp {
		font-size: 16px;
		color: #28a3b1;
		margin-top: 10px;
		cursor: pointer;
	}

	.mh-myp1 {
		font-size: 12px;
		margin-top: 10px;
	}

	.mh-myp2 {
		font-size: 12px;
		margin-top: 20px;
		color: #808080;
		width: 100%;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
</style>



// WEBPACK FOOTER //
// src/components/Usercenter/mhCollect.vue